export function view(value) {
  return !!value ? 'Images' : 'ImageSeriesList'
}
